"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _postcss = _interopRequireDefault(require("postcss"));

var _postcssJs = _interopRequireDefault(require("postcss-js"));

var _juice = _interopRequireDefault(require("juice"));

var _jss = require("jss");

var _jssPresetDefault = _interopRequireDefault(require("jss-preset-default"));

var _react = require("react");

var _server = require("react-dom/server");

var _reactJss = require("react-jss");

var _ = require("../");

var _assign = _interopRequireDefault(require("lodash/assign"));

var _get = _interopRequireDefault(require("lodash/get"));

//$FlowIgnore
//$FlowIgnore
function removeEmptyRules(value) {
  return value.replace(/^(\.|#)[\w-]+ \{\n\}$/gm, "");
}

function processContent() {
  return _processContent.apply(this, arguments);
}

function _processContent() {
  _processContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var content,
        components,
        jss,
        sheets,
        body,
        cssRoot,
        _yield$postcss$proces,
        css,
        _args2 = arguments;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            content = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
            components = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : [];
            jss = (0, _jss.create)((0, _jssPresetDefault["default"])());
            jss.use({
              onChangeValue: function onChangeValue(value, prop, rule) {
                if (typeof value === "string" && value.trim() === "") {
                  return "";
                }

                return value;
              }
            });
            sheets = new _reactJss.SheetsRegistry();
            body = (0, _server.renderToStaticMarkup)( /*#__PURE__*/(0, _react.createElement)(_reactJss.JssProvider, {
              registry: sheets,
              jss: jss
            }, _.Tools.renderReact({
              content: content || [],
              components: components
            })));
            cssRoot = _postcssJs["default"].objectify(_postcss["default"].parse(removeEmptyRules(sheets.toString()))); // extend the body color

            if ((0, _get["default"])(content, "[0].attrs.backgroundColor")) {
              cssRoot["html, body"] = (0, _assign["default"])({}, cssRoot["html, body"] || {}, {
                backgroundColor: content[0].attrs.backgroundColor
              });
            }

            _context2.next = 10;
            return (0, _postcss["default"])().process(cssRoot, {
              parser: _postcssJs["default"]
            });

          case 10:
            _yield$postcss$proces = _context2.sent;
            css = _yield$postcss$proces.css;
            return _context2.abrupt("return", {
              body: body,
              css: css
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _processContent.apply(this, arguments);
}

function renderHtml(body, css) {
  var html = /*#__PURE__*/(0, _react.createElement)("html", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/(0, _react.createElement)("head", null, /*#__PURE__*/(0, _react.createElement)("meta", {
    httpEquiv: "Content-Type",
    content: "text/html; charset=UTF-8"
  }), /*#__PURE__*/(0, _react.createElement)("style", {
    dangerouslySetInnerHTML: {
      __html: css
    }
  })), /*#__PURE__*/(0, _react.createElement)("body", {
    dangerouslySetInnerHTML: {
      __html: body
    }
  }));
  return "<!doctype html>\n" + (0, _server.renderToStaticMarkup)(html);
}

var _default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(options) {
    var _options$inlineCss, inlineCss, content, components, _yield$processContent, body, css, html;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _options$inlineCss = options.inlineCss, inlineCss = _options$inlineCss === void 0 ? false : _options$inlineCss, content = options.content, components = options.components;
            _context.next = 3;
            return processContent(content, components);

          case 3:
            _yield$processContent = _context.sent;
            body = _yield$processContent.body;
            css = _yield$processContent.css;
            html = renderHtml(body, css);

            if (!inlineCss) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", (0, _juice["default"])(html));

          case 9:
            return _context.abrupt("return", html);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

exports["default"] = _default;